import { useState } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

// Tooltip that opens on hover/focus (desktop) AND on tap (phones/tablets).
// Radix tooltips ignore touch and close on click, so the open state is held here:
// a tap opens it, a tap anywhere else closes it.
export default function InfoTip({ tip, children, side = "bottom" }) {
  const [open, setOpen] = useState(false);
  return (
    <Tooltip open={open} onOpenChange={setOpen}>
      <TooltipTrigger asChild
        onClick={(e) => { e.preventDefault(); setOpen(true); }}>
        {children}
      </TooltipTrigger>
      <TooltipContent side={side} className="max-w-[260px] leading-snug">{tip}</TooltipContent>
    </Tooltip>
  );
}
